module.exports = __webpack_public_path__ + "img/6354845601796390235861783.6f29a31a.jpg";